export const HR_EMPLOYEE_NOTIFICATIONS = '/hr/EmployeeNotifications'
export const HR_EMPLOYEE_NOTIFICATIONS_LATEST = `${HR_EMPLOYEE_NOTIFICATIONS}/latest`

export function employeeNotificationRead(id: number) {
  return `${HR_EMPLOYEE_NOTIFICATIONS}/${id}/read`
}

export const HR_EMPLOYEE_NOTIFICATIONS_READ_ALL = `${HR_EMPLOYEE_NOTIFICATIONS}/read`

export function employeeNotificationById(id: number) {
  return `${HR_EMPLOYEE_NOTIFICATIONS}/${id}`
}
